"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeAdAnalyticsVideoIndexKeyFrame = void 0;
const AdAnalyticsVideo_1 = require("../entity/AdAnalyticsVideo");
const timeObject_1 = require("./timeObject");
const createSomeAdAnalyticsVideoIndexKeyFrame = ({ thumbnailImageUrl = '', start = timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 10 }), end = timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 15 }), } = {}) => new AdAnalyticsVideo_1.AdAnalyticsVideoIndexKeyFrame({
    thumbnailImageUrl,
    start,
    end,
});
exports.createSomeAdAnalyticsVideoIndexKeyFrame = createSomeAdAnalyticsVideoIndexKeyFrame;
